import { render, staticRenderFns } from "./analyticsPurchasingDashboard.vue?vue&type=template&id=7c17755c&"
import script from "./analyticsPurchasingDashboard.vue?vue&type=script&lang=js&"
export * from "./analyticsPurchasingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports